"use client";
import { ArrowUpRight } from "lucide-react";
import { useRegisterTypeModal } from "@/components/auth/RegisterTypeModalProvider";
import styles from "./home.module.css";
export default function RegisterButton({
  light = false,
  label = "Começar agora",
  className = "",
}: { light?: boolean; label?: string; className?: string }) {
  const { openRegisterTypeModal } = useRegisterTypeModal();
  return (
    <button
      type="button"
      onClick={openRegisterTypeModal}
      className={`${styles.button} ${light ? styles.lightButton : styles.primaryButton} ${className}`}
    >
      {label} <ArrowUpRight size={17} />
    </button>
  );
}
